<template>
  <div class="c-video-player u-wrapper-panel u-overflow-h">
    <video ref="video" :src="src" class="u-fit-cover" @ended="onVideoEnded"/>
    <div v-if="poster !== '' && !isPlaying" class="u-wrapper-panel" @click="onTogglePlay">
      <img :src="poster" class="c-video-player__poster u-fit-cover"/>
    </div>
  </div>
</template>

<script>
export default
{
  props:
  {
    src: { type: String, default: '' },
    poster: { type: String, default: '' },
    forcePlay: { type: Boolean, default: false },
    controls: { type: Boolean, default: false },
    onPlay: { type: Function, default: ()=>{return} },
    onPause: { type: Function, default: ()=>{return} },
    muted: { type: Boolean, default: true },
    loop: { type: Boolean, default: false },
    isStoppable: { type: Boolean, default: true }
  },

  data()
  {
    return {
      isPlaying: false,
      isFullScreen: false
    }
  },

  created() {
    this.hasPlay = false
  },

  mounted() {
    this.video = this.$refs.video

    if( this.video == void 0 ) { return }

    if( this.muted ){
      this.video.muted = true
      this.video.setAttribute('muted', '')
    }
    else{
      this.video.muted = false
    }

    if( this.forcePlay ) {
      this.video.setAttribute('autoplay', 'autoplay')
      this.play()
    }

    if( this.loop )
      this.video.setAttribute('loop', 'loop')
  },

  watch: {
    forcePlay() {
      if( this.forcePlay ) {
        this.play()
      }
      else {
        this.pause()
      }
    },

    isPlaying() {
      if( this.isPlaying ) {
        this.$el.classList.remove('is-paused')
        this.$el.classList.add('is-started')
        this.$el.classList.add('is-playing')
      }
      else {
        this.$el.classList.add('is-paused')
        this.$el.classList.remove('is-playing')
      }
    }
  },

  methods: {
    checkPlay() {
      setTimeout( ()=>{
        if( !this.video.paused ){
          this.isPlaying  = true
        }
      }, 100)
    },

    onTogglePlay() {
      if( !this.isStoppable || this.video == void 0 ) { return }

      if(this.isPlaying) {
        this.pause()
      }
      else {
        this.play()
      }
    },

    play() {
      this.hasPlay = true
      this.video.play()
      this.checkPlay()
    },

    pause() {
      this.isPlaying = false
      this.video.pause()
    },

    onVideoEnded() {
      this.$el.classList.remove('is-started')

      if( this.loop ) {
        this.play()
        this.video.currentTime = 0
        this.play()
      }
    },
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/easings'

.c-video-player__play
    transform scale(1) translateZ(0)
    transition transform 0.9s ease-out-quint, opacity .5s

    .is-playing &
        opacity 0
        transition transform 0.9s ease-out-quint, opacity 0s

.c-video-player__poster
    transform translateZ(0)
    transition opacity .5s

    .is-started &
        opacity 0

.c-video-player__controls
    z-index 2
    opacity 0
    transform translateZ(0)

    .is-started &
        opacity 1
        transition opacity .6s

.c-video-player__btn
    background none
    border none
</style>